// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__B5Su2","modal":"Modal_modal__20oWW","slide-down":"Modal_slide-down__1bLjo"};